import { render, staticRenderFns } from "./RaPetRemembranceButton.vue?vue&type=template&id=4768a080"
import script from "./RaPetRemembranceButton.vue?vue&type=script&lang=js"
export * from "./RaPetRemembranceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports